import { Flex, Text } from '@chakra-ui/react';
import { rowH } from '../DetailedStatistics';
import { useAppSelector } from 'store/hooks';
import { selectCallouts } from 'store/slices/companySetting';
import { ACTIVITIES } from 'types';

const Summary = ({
    data,
}: {
    data: Array<{
        name: ACTIVITIES;
        value: any;
    }>;
}) => {
    const callouts = useAppSelector(selectCallouts);

    return (
        <Flex
            flexDirection="column"
            width="170px"
            flexShrink={0}
            borderRight="1px"
            borderColor="gray.200"
            gap="16px"
            padding="24px"
        >
            {data.map(item => (
                <Text fontSize="14px" height={rowH} fontWeight="500" color="gray.500" key={item.name}>
                    {callouts[item.name]}: &nbsp;
                    <Text as="span" color="gray.900">
                        {item.value}
                    </Text>
                </Text>
            ))}
        </Flex>
    );
};

export default Summary;
